import {Progress} from "antd";
import React from "react";

const CircleProgressWithFraction = ({ numer, denom }) => {
    const percent = denom > 0 ? (numer / denom * 100) : 0;
    return (<Progress
        type="circle"
        percent={percent}
        size={100}
        strokeWidth={5}
        format={() => <FractionComponent numerator={numer} denominator={denom} />}
    />)
};

const FractionComponent = ({ numerator, denominator }) => {
    return (
        <div className={'flexColumn flexAlignCentre flexInline'}>
            <span style={{
                fontSize: '1em',
                lineHeight: 1,
                marginRight: '20px'
            }}>
        {numerator}
      </span>
            <div style={{
                width: '46px',
                transform: 'rotate(310deg)',
                backgroundColor: 'currentColor',
                height: '2px'
            }} />
            <span style={{
                fontSize: '1em',
                lineHeight: 1,
                marginLeft:'20px'
            }}>
        {denominator}
      </span>
        </div>
    );
};
export default CircleProgressWithFraction;